import React, { useEffect, useRef, useState } from 'react';
import {Link} from 'react-router-dom'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import BgImg from "../assets/images/bg/bg.png"
import PlusIcon from "../assets/images/icons/Plus.svg"
import ReduceIcon from "../assets/images/icons/Reduce.svg"
import LayoutHeader from '../layous/headers';
import Layoutfooter from '../layous/footer';
import { getBanners, getCategories, getYears } from '../controllers/apicontroller';



const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 5
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1.1
    }
};
const Main = () => {
    const currentYear = new Date().getFullYear();
    const [loaded, setLoaded] = useState(false)
    const [banners, setBanners] = useState([])
    const [category, setCategory] = useState([])
    const [years, setYears] = useState([])
    const [year, setYear] = useState(currentYear)
    let componentMounted = useRef(true);
    useEffect(() => {
        if(componentMounted.current){
            init()
        }

        return () => {
            componentMounted.current = false;
        }
    },[])
    const init = async() => {
        setLoaded(false)
        await fetchBanner()
        await fetchCategory(currentYear)
        await fetchYears()
        setLoaded(true)
    }
    const fetchBanner = async () => {
        const response = await getBanners('')
        if(response.status == 200){
            const data = await response.json()
            console.log('fetch banners ', data.data)
            setBanners(data.data)
        }
    }

    const fetchCategory = async(year) => {
        const response = await getCategories(`?type=ita&year=${year}`)
        if(response.status == 200){
            const data = await response.json()
            console.log('fetch category ', data.data)
            setCategory(data.data)
        }

    }    
    const fetchYears = async() => {
        const response = await getYears(`?type=ita`)
        if(response.status == 200){
            const data = await response.json()
            setYears(data)
        }

    }
    const changeYear = async(e) => {
        setLoaded(false)
        await fetchCategory(e.target.value)
        setYear(e.target.value)
        setLoaded(true)
    }

    const handleClick = (e) => {
        const tempBlogs = [...category];
        tempBlogs[e]['open'] = category[e].open ? category[e].open === "1" ? "0" : "1" : "0";
        console.log('handle click : ', tempBlogs[e]['open'])
        setCategory(tempBlogs);
    }

    console.log(category)

    return (
        <>
            <LayoutHeader />
            <section className="header-title">
                <h2 className='fw-bolder text-green py-4'>ประเมินคุณธรรมและความโปร่งใส<br />ในการดำเนินงานของหน่วยงานภาครัฐ (ITA)</h2>
                <div className="banners mt-4 pt-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 px-0">
                                <Carousel arrows={false} showDots={true} responsive={responsive}>
                                    {banners?.map((banner,b) => (
                                        <a href={banner.url} target={banner.blank ? '_blank' : ''} className='p-3 d-block' key={b}><img src={banner.origin_url} className="w-100" /></a>
                                    ))}
                                </Carousel>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {loaded ?
            <section id="item-list" style={{ backgroundImage: `url(${BgImg})`, backgroundPosition: "center center", backgroundSize: "cover", backgroundRepeat: "no-repeat" }}>
                <div className="container">
                    <div className="mt-4 mb-3" id="">
                        <div className='d-flex flex-row-reverse' >
                            <select className="form-select d-inline-block form-select-custom font-kanit" value={year} onChange={e => changeYear(e)}>
                                <option>เลือกปี</option>
                                {years?.map((opt,y) => (
                                    <option value={opt.year} key={y}>ปี {Number(opt.year)+543}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className='text-start pb-4'>
                        <h2 className='fw-bolder text-green  font-kanit'>ปี {parseInt(year)+543}</h2>
                        <div className='w-75 hr-custom' style={{height: "3px"}}></div>
                    </div>
                    <div className="row grid" id="ita-result">
                        {category?.map((val, index) => (
                            <div className="col-md-4 col-lg-4 col-sm-4 mb-2 grid-item px-3" key={index}>
                                <a className={`article-title ${val.open ? val.open === '1' ? "active" : "deactive" : "active"}`} role="button" onClick={e => handleClick(index)}>
                                    <img src={PlusIcon} className={`me-2 float-left menu-icon-plus ${val.open ? val.open === '1' ? "d-none" : "d-inline-block" : "d-none"}`} />
                                    <img src={ReduceIcon} className={`me-2 float-left menu-icon-reduce ${val.open ? val.open === '1' ? "d-inline-block" : "d-none" : "d-inline-block"}`} />
                                    <div className="ms-1 float-left"> {val.name}</div>
                                </a>
                                <div className={`collapse ${val.open ? val.open === '1' && "show" : "show"}`} id="tab-0">
                                    <div className="card card-body">
                                        <ul className="article-links">
                                            {val.contents.map((vall, indexx) => (
                                                <li key={indexx}>
                                                    {vall.type == 'link' ?
                                                        <Link to={vall.description} target='_blank'>{vall.subject}</Link>
                                                    :
                                                        <Link to={`/view/ita/${vall.id}`}>{vall.subject}</Link>
                                                    }
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            : null}
            <Layoutfooter />

        </>
    );
};

export default Main;